module.exports = __webpack_public_path__ + "img/DNARepair-LUCA_10X_LU.885c5ad7.png";